<div class="pantalla clara">

    <div class="row">
        <div class="col-12 col-lg-6 offset-lg-3 ">
            <span class="titulo">Contacto</span>
        </div>
    </div>

    <div class="row">
        <div class="col-12 col-lg-6 offset-lg-3 mt-3 bg-white p-4">
            <h5 class="font-weight-bold ml-0">Envíanos tu consulta</h5>
            <P>Completa los campos de abajo y envíanos tu consulta.</P>
            <div class="bg-light p-3 mt-3 text-left">
                <small>
                    Puedes enviarnos tu consulta o inquietud teniendo en cuenta que vamos a proteger tus datos perosnales con el articulo
                    ....</small>
            </div>

            <br />


            <div class="row">
                <div class="col-12 col-lg-8">
                    <form class="text-center" [formGroup]="contactoForm" (ngSubmit)="onSubmit() ">

                        <!-- Nombre -->
                        <div class="form-group mb-4 text-left lg light">
                            <label for="nombre">Nombre</label>
                            <input type="text" class="form-control" id="nombre" formControlName="nombre" placeholder="Ingrese su nombre">

                            <ng-container *ngIf="contactoForm.get('nombre').invalid && contactoForm.get('nombre').touched">
                                <div *ngIf="contactoForm.get('nombre').errors?.required" class="text-danger">
                                    Debe ingresar un nombre.
                                </div>
                            </ng-container>
                        </div>

                        <!-- Email -->
                        <div class="form-group mb-4 text-left lg light">
                            <label for="email">Email</label>
                            <input type="email" class="form-control" id="email" formControlName="email" placeholder="Ingrese su email">
                            <small class="form-text text-muted">Nunca compartiremos tu correo con nadie.</small>

                            <ng-container *ngIf="contactoForm.get('email').invalid && contactoForm.get('email').touched">
                                <div *ngIf="contactoForm.get('email').errors?.required" class="text-danger">
                                    Debe ingresar su correo electrónico.
                                </div>
                                <div *ngIf="contactoForm.get('email').errors?.email" class="text-danger">
                                    El correo debe ser real!
                                </div>
                            </ng-container>
                        </div>

                        <!-- Texto -->
                        <div class="form-group mb-4 text-left lg light">
                            <label for="texto">Mensaje</label>
                            <textarea class="form-control" id="texto" formControlName="texto" placeholder="Ingrese su mensaje" rows="3"></textarea>

                            <ng-container *ngIf="contactoForm.get('texto').invalid && contactoForm.get('texto').touched">
                                <div *ngIf="contactoForm.get('texto').errors?.required" class="text-danger">
                                    Debe ingresar un mensaje para enviar la consulta.
                                </div>
                            </ng-container>
                        </div>


                        <!-- ENVIAR RESET -->
                        <div class="form-group mt-3 text-left">
                            <button class="btn btn-primary my-4" type="submit" [ngClass]="{ disabled: !contactoForm.valid }">

                                <span class="text-white spinner-border spinner-border-sm" *ngIf="cargando" role="status" aria-hidden="true"></span>
                                <span class="text-white font-weight-bold ml-2" *ngIf="cargando">ENVIANDO </span>
                                <span class="text-white font-weight-bold" *ngIf="!cargando">ENVIAR CONSULTA</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>


        </div>
    </div>




</div>